import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiMinus, FiExternalLink } from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const FaqItemRo = ({ faq, index }) => {
  const [open, setOpen] = useState(index === 0);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.07 }}
      className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${
        open ? 'border-brand-accent/30 bg-brand-surface' : 'border-white/5 bg-brand-dark hover:border-white/10'
      }`}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-start gap-4 p-6 text-left"
      >
        <span
          className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mt-0.5 transition-colors ${
            open ? 'bg-brand-accent text-brand-dark' : 'bg-white/5 text-gray-400'
          }`}
        >
          <SafeIcon icon={open ? FiMinus : FiPlus} className="text-sm" />
        </span>
        <h3 className={`font-display font-bold text-lg leading-snug flex-1 transition-colors ${open ? 'text-white' : 'text-gray-200'}`}>
          {faq.q}
        </h3>
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="px-6 pb-6 pl-[3.5rem]">
              {faq.a && (
                <p className="text-gray-300 leading-relaxed text-base mb-4">{faq.a}</p>
              )}
              {faq.link && (
                <a
                  href={faq.link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-brand-accent hover:text-white text-sm font-medium transition-colors"
                >
                  {faq.link.label} <SafeIcon icon={FiExternalLink} />
                </a>
              )}
              {faq.editions && (
                <div className="flex flex-col sm:flex-row gap-3 mt-2">
                  {faq.editions.map((ed) => (
                    <a
                      key={ed.label}
                      href={ed.href}
                      target="_blank"
                      rel="noreferrer"
                      className={`flex flex-col items-center justify-center gap-0.5 px-6 py-4 rounded-xl font-bold text-sm transition-all ${
                        ed.primary
                          ? 'bg-brand-accent text-brand-dark hover:bg-brand-accentHover'
                          : 'bg-white/5 text-white border border-white/15 hover:bg-white/10'
                      }`}
                    >
                      <span>{ed.label}</span>
                      <span className={`text-xs font-normal ${ed.primary ? 'text-brand-dark/70' : 'text-gray-400'}`}>
                        {ed.price}
                      </span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default FaqItemRo;